import { render, staticRenderFns } from "./SellersAccountsReceivable.vue?vue&type=template&id=af28faa6&scoped=true"
import script from "./SellersAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./SellersAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./SellersAccountsReceivable.vue?vue&type=style&index=0&id=af28faa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af28faa6",
  null
  
)

export default component.exports